module.exports = __webpack_public_path__ + "static/media/league-active.3b9c5e71.svg";